(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["media-grid-v3"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nn-media-grid-v3-slider')) {
    customElements.define(
      'nn-media-grid-v3-slider',
      class NNMediaGridV3Slider extends HTMLElement {
        connectedCallback() {
          if (this.dataset.mobileSlider !== 'slider') return;

          this.abortController?.abort();
          this.abortController = new AbortController();
          this.track = this.querySelector('[data-mobile-slider-track]');
          this.items = Array.from(this.querySelectorAll('[data-mobile-slider-item]'));
          this.dots = Array.from(this.querySelectorAll('[data-mobile-slider-dot]'));
          this.status = this.querySelector('[data-mobile-slider-status]');
          this.mobileQuery = window.matchMedia('(max-width: 699px)');
          this.reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.autoplayEnabled = this.dataset.mobileAutoplay === 'true';
          this.autoplayDelay = Number.parseInt(this.dataset.mobileAutoplayDelay, 10) || 3000;
          this.activeIndex = 0;

          if (!this.track || this.items.length < 2) return;

          const signal = this.abortController.signal;

          this.track.addEventListener('scroll', () => this.update(), { passive: true, signal });
          this.track.addEventListener('pointerdown', () => this.stopAutoplay(), { passive: true, signal });
          this.track.addEventListener('pointerup', () => this.startAutoplay(), { passive: true, signal });
          this.track.addEventListener('pointercancel', () => this.startAutoplay(), { passive: true, signal });
          this.track.addEventListener('focusin', () => this.stopAutoplay(), { signal });
          this.track.addEventListener('focusout', () => this.startAutoplay(), { signal });
          this.mobileQuery.addEventListener('change', () => this.handleModeChange(), { signal });
          this.reducedMotionQuery.addEventListener('change', () => this.handleModeChange(), { signal });
          document.addEventListener('visibilitychange', () => this.handleVisibilityChange(), { signal });
          this.resizeObserver = new ResizeObserver(() => this.update());
          this.resizeObserver.observe(this.track);

          requestAnimationFrame(() => {
            this.update();
            this.startAutoplay();
          });
        }

        disconnectedCallback() {
          this.stopAutoplay();
          this.abortController?.abort();
          this.resizeObserver?.disconnect();
        }

        handleModeChange() {
          this.update();

          if (this.mobileQuery.matches && !this.reducedMotionQuery.matches) {
            this.startAutoplay();
          } else {
            this.stopAutoplay();
          }
        }

        handleVisibilityChange() {
          if (document.hidden) {
            this.stopAutoplay();
          } else {
            this.startAutoplay();
          }
        }

        startAutoplay() {
          this.stopAutoplay();

          if (
            !this.autoplayEnabled
            || !this.mobileQuery?.matches
            || this.reducedMotionQuery?.matches
            || document.hidden
          ) {
            return;
          }

          this.autoplayTimer = window.setTimeout(() => {
            this.advance();
            this.startAutoplay();
          }, this.autoplayDelay);
        }

        stopAutoplay() {
          window.clearTimeout(this.autoplayTimer);
          this.autoplayTimer = null;
        }

        advance() {
          const nextIndex = (this.activeIndex + 1) % this.items.length;
          const target = this.items[nextIndex];

          if (!target) return;

          const trackRect = this.track.getBoundingClientRect();
          const targetRect = target.getBoundingClientRect();
          const targetLeft = this.track.scrollLeft + targetRect.left - trackRect.left;

          this.track.scrollTo({
            left: targetLeft,
            behavior: 'smooth'
          });
        }

        update() {
          if (!this.mobileQuery?.matches || !this.track) return;

          let activeIndex = 0;
          let shortestDistance = Number.POSITIVE_INFINITY;
          const trackLeft = this.track.getBoundingClientRect().left;

          this.items.forEach((item, index) => {
            const distance = Math.abs(item.getBoundingClientRect().left - trackLeft);

            if (distance < shortestDistance) {
              shortestDistance = distance;
              activeIndex = index;
            }
          });

          this.activeIndex = activeIndex;

          this.dots.forEach((dot, index) => {
            dot.classList.toggle('is-active', index === activeIndex);
          });

          if (this.status) {
            const template = this.dataset.statusTemplate || '__index__ / __count__';
            this.status.textContent = template
              .replace('__index__', String(activeIndex + 1))
              .replace('__count__', String(this.items.length));
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nn-highlight-link-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nn-highlight-slider')) {
    customElements.define(
      'nn-highlight-slider',
      class NNHighlightSlider extends HTMLElement {
        connectedCallback() {
          this.abortController?.abort();
          this.abortController = new AbortController();
          this.track = this.querySelector('[data-slider-track]');
          this.items = Array.from(this.querySelectorAll('[data-slider-item]'));
          this.controls = this.querySelector('[data-slider-controls]');
          this.prevButton = this.querySelector('[data-slider-prev]');
          this.nextButton = this.querySelector('[data-slider-next]');
          this.status = this.querySelector('[data-slider-status]');
          this.progress = this.querySelector('[data-slider-progress]');
          this.progressThumb = this.querySelector('[data-slider-progress-thumb]');

          if (!this.track || this.items.length === 0) return;

          const signal = this.abortController.signal;

          this.prevButton?.addEventListener('click', () => this.scroll(-1), { signal });
          this.nextButton?.addEventListener('click', () => this.scroll(1), { signal });
          this.track.addEventListener('scroll', () => this.update(), { passive: true, signal });

          this.resizeObserver = new ResizeObserver(() => this.update());
          this.resizeObserver.observe(this.track);

          requestAnimationFrame(() => this.update());
        }

        disconnectedCallback() {
          this.abortController?.abort();
          this.resizeObserver?.disconnect();
        }

        scroll(direction) {
          const amount = Math.max(180, this.track.clientWidth * 0.82);
          this.track.scrollBy({ left: direction * amount, behavior: 'smooth' });
        }

        update() {
          const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
          const current = Math.max(0, this.track.scrollLeft);
          const hasOverflow = maxScroll > 2;

          this.controls?.toggleAttribute('hidden', !hasOverflow);
          this.progress?.toggleAttribute('hidden', !hasOverflow);
          this.track.classList.toggle('is-centered', !hasOverflow && window.innerWidth >= 700);

          if (this.prevButton) this.prevButton.disabled = current <= 2;
          if (this.nextButton) this.nextButton.disabled = current >= maxScroll - 2;

          if (this.progressThumb && hasOverflow) {
            const visibleRatio = Math.min(1, this.track.clientWidth / this.track.scrollWidth);
            const size = Math.max(16, visibleRatio * 100);
            const offsetRange = 100 - size;
            const progress = maxScroll > 0 ? current / maxScroll : 0;
            this.progressThumb.style.setProperty('--nn-highlight-progress-size', `${size}%`);
            this.progressThumb.style.setProperty('--nn-highlight-progress-offset', `${progress * offsetRange}%`);
          }

          if (this.status) {
            const center = current + this.track.clientWidth / 2;
            let activeIndex = 0;
            let shortestDistance = Number.POSITIVE_INFINITY;

            this.items.forEach((item, index) => {
              const itemCenter = item.offsetLeft + item.offsetWidth / 2;
              const distance = Math.abs(center - itemCenter);

              if (distance < shortestDistance) {
                shortestDistance = distance;
                activeIndex = index;
              }
            });

            const template = this.dataset.statusTemplate || '__index__ / __count__';
            this.status.textContent = template
              .replace('__index__', String(activeIndex + 1))
              .replace('__count__', String(this.items.length));
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nn-naked-ritual"] && !Shopify.designMode) return;
  try {
    
  const ritualReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function initRitualVideos() {
    document.querySelectorAll('.nl-ritual__video').forEach(video => {
      if (video.dataset.ritualReady) return;
      video.dataset.ritualReady = 'true';
      const player = video.closest('.nl-ritual__player');
      const frame = player.parentElement;
      const dialog = frame.querySelector('.nl-ritual__video-dialog');
      const toggle = player.querySelector('[data-ritual-toggle]');
      const enlarge = player.querySelector('[data-ritual-enlarge]');
      const close = player.querySelector('[data-ritual-close]');
      let prepared = false;
      let inViewport = false;
      let userPaused = false;
      const controller = new AbortController();
      const lockMute = () => {
        video.defaultMuted = true;
        if (!video.muted) video.muted = true;
        if (video.volume !== 0) video.volume = 0;
      };
      const syncPlayback = () => {
        toggle.setAttribute('aria-label', video.paused ? toggle.dataset.play : toggle.dataset.pause);
      };
      const prepareVideo = () => {
        lockMute();
        video.playsInline = true;
        if (!prepared) {
          prepared = true;
          video.preload = 'auto';
          video.load();
        }
      };
      const playMuted = () => {
        prepareVideo();
        video.play().catch(syncPlayback);
      };
      lockMute();
      video.addEventListener('volumechange', lockMute);
      video.addEventListener('play', lockMute);
      video.addEventListener('play', syncPlayback);
      video.addEventListener('pause', syncPlayback);
      video.addEventListener('error', () => {
        prepared = false;
        video.pause();
        syncPlayback();
      });
      video.addEventListener('contextmenu', event => event.preventDefault());
      const togglePlayback = () => {
        if (video.paused) {
          userPaused = false;
          playMuted();
        } else {
          userPaused = true;
          video.autoplay = false;
          video.pause();
        }
      };
      toggle.addEventListener('click', togglePlayback);
      video.addEventListener('click', togglePlayback);
      enlarge.hidden = typeof dialog.showModal !== 'function';
      enlarge.addEventListener('click', () => {
        const wasPlaying = !video.paused;
        enlarge.hidden = true;
        close.hidden = false;
        dialog.append(player);
        dialog.showModal();
        close.focus();
        if (wasPlaying) playMuted();
      });
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => {
        const wasPlaying = !video.paused;
        frame.prepend(player);
        close.hidden = true;
        enlarge.hidden = false;
        enlarge.focus();
        if (wasPlaying) playMuted();
      });
      player.querySelector('.nl-ritual__video-controls').hidden = false;
      syncPlayback();
      const syncViewportPlayback = () => {
        if (document.hidden) {
          video.pause();
          return;
        }
        if (dialog.open) return;
        if (!inViewport) {
          video.pause();
        } else if (!userPaused && !ritualReducedMotion.matches && !navigator.connection?.saveData) {
          playMuted();
        }
      };
      const observer = typeof IntersectionObserver === 'function' ? new IntersectionObserver(entries => {
        inViewport = entries[0].isIntersecting;
        syncViewportPlayback();
      }) : null;
      const preloadObserver = typeof IntersectionObserver === 'function' ? new IntersectionObserver(entries => {
        if (entries[0].isIntersecting && !document.hidden && !ritualReducedMotion.matches && !navigator.connection?.saveData) prepareVideo();
      }, { rootMargin: '300px 0px' }) : null;
      preloadObserver?.observe(frame);
      if (observer) observer.observe(frame);
      else {
        inViewport = true;
        syncViewportPlayback();
      }
      document.addEventListener('visibilitychange', syncViewportPlayback, { signal:controller.signal });
      document.addEventListener('shopify:section:unload', event => {
        if (!event.target.contains(frame)) return;
        observer?.disconnect();
        preloadObserver?.disconnect();
        video.pause();
        controller.abort();
      }, { signal:controller.signal });
    });
  }
  function pauseRitualMotion() {
    if (!ritualReducedMotion.matches) return;
    document.querySelectorAll('.nl-ritual__video').forEach(video => {
      video.removeAttribute('autoplay');
      video.pause();
    });
  }
  initRitualVideos();
  document.addEventListener('DOMContentLoaded', initRitualVideos);
  document.addEventListener('shopify:section:load', initRitualVideos);
  ritualReducedMotion.addEventListener('change', pauseRitualMotion);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nn-swipe-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nn-swipe-grid')) {
    customElements.define('nn-swipe-grid', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.track = this.querySelector('.nn-swipe-grid__track');
        this.slides = Array.from(this.querySelectorAll('.nn-swipe-grid__slide'));
        this.dots = Array.from(this.querySelectorAll('.nn-swipe-grid__dot'));
        this.status = this.querySelector('.nn-swipe-grid__status');
        this.playback = this.querySelector('[data-playback]');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.autoplay = this.dataset.autoplay === 'true' && this.slides.length > 1;
        this.duration = Math.max(4, Number(this.dataset.cycleSpeed) || 6) * 1000;
        this.userPaused = false;
        this.focusPaused = false;
        this.hovering = false;
        this.interacting = false;
        this.visible = false;
        this.index = 0;
        this.direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        this.querySelectorAll('[data-control]').forEach((control) => control.hidden = false);
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.select(index), options));
        this.querySelector('[data-previous]')?.addEventListener('click', () => this.step(-1), options);
        this.querySelector('[data-next]')?.addEventListener('click', () => this.step(1), options);
        this.playback?.addEventListener('click', () => {
          if (this.userPaused || this.focusPaused) {
            this.userPaused = false;
            this.focusPaused = false;
          } else {
            this.userPaused = true;
          }
          this.schedule();
        }, options);
        this.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse') return;
          this.hovering = true;
          this.schedule();
        }, options);
        this.addEventListener('pointerleave', () => {
          this.hovering = false;
          this.schedule();
        }, options);
        this.addEventListener('focusin', (event) => {
          if (event.target !== this.playback) this.focusPaused = true;
          this.schedule();
        }, options);
        this.addEventListener('focusout', (event) => {
          if (this.contains(event.relatedTarget)) return;
          this.focusPaused = false;
          this.schedule();
        }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => this.schedule(), options);
        this.track.addEventListener('scroll', () => {
          this.stopPlayback();
          clearTimeout(this.settleTimer);
          this.settleTimer = setTimeout(() => this.settle(), 150);
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => {
            if (!this.pointer?.dragging) this.update(this.nearestIndex());
          });
        }, { ...options, passive: true });
        this.track.addEventListener('keydown', (event) => {
          if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
          let index;
          if (event.key === 'ArrowRight') index = this.index + this.direction;
          if (event.key === 'ArrowLeft') index = this.index - this.direction;
          if (event.key === 'Home') index = 0;
          if (event.key === 'End') index = this.slides.length - 1;
          if (index === undefined) return;
          event.preventDefault();
          this.track.focus({ preventScroll: true });
          this.select(index);
        }, options);
        this.track.addEventListener('pointerdown', (event) => {
          this.suppressClick = false;
          this.interacting = true;
          this.cancelTransition();
          this.stopPlayback();
          if (event.pointerType !== 'mouse' || event.button !== 0 || this.slides.length < 2) return;
          // Stop an unfinished slide animation before recording the drag origin.
          this.track.scrollTo({ left: this.track.scrollLeft, behavior: 'instant' });
          this.pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, scroll: this.track.scrollLeft, index: this.nearestIndex(), dragging: false };
        }, options);
        this.track.addEventListener('pointermove', (event) => {
          const pointer = this.pointer;
          if (!pointer || pointer.id !== event.pointerId) return;
          const dx = event.clientX - pointer.x;
          if (!pointer.dragging && Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(event.clientY - pointer.y)) {
            pointer.dragging = true;
            this.track.setPointerCapture(event.pointerId);
            this.track.classList.add('is-dragging');
            this.track.classList.remove('is-settling');
          }
          if (!pointer.dragging) return;
          event.preventDefault();
          this.track.scrollLeft = pointer.scroll - dx;
        }, options);
        this.track.addEventListener('pointerup', (event) => this.endDrag(event), options);
        this.track.addEventListener('pointercancel', (event) => this.endDrag(event, true), options);
        this.track.addEventListener('lostpointercapture', (event) => this.endDrag(event, true), options);
        this.track.addEventListener('pointerleave', () => {
          if (!this.pointer?.dragging) {
            this.pointer = null;
            this.interacting = false;
            this.schedule();
          }
        }, options);
        this.track.addEventListener('dragstart', (event) => event.preventDefault(), options);
        this.track.addEventListener('click', (event) => {
          if (!this.suppressClick || event.detail === 0) return;
          event.preventDefault();
          event.stopPropagation();
          this.suppressClick = false;
        }, { ...options, capture: true });
        this.addEventListener('shopify:block:select', (event) => {
          this.editorSelected = true;
          const slide = event.target.closest('.nn-swipe-grid__slide');
          const index = this.slides.indexOf(slide);
          if (index >= 0) this.select(index, false);
        }, options);
        this.addEventListener('shopify:block:deselect', () => {
          this.editorSelected = false;
          this.schedule();
        }, options);
        this.resizeObserver = new ResizeObserver(() => {
          const width = this.track.clientWidth;
          if (width && width !== this.width) {
            this.width = width;
            this.select(this.index, false);
          }
        });
        this.resizeObserver.observe(this.track);
        this.visibilityObserver = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          this.schedule();
        }, { threshold: 0 });
        this.visibilityObserver.observe(this);
        this.update(0);
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        this.stopPlayback();
        this.cancelTransition();
        clearTimeout(this.settleTimer);
        cancelAnimationFrame(this.scrollFrame);
        this.pointer = null;
        this.track.classList.remove('is-dragging', 'is-settling');
      }
      nearestIndex() {
        return Math.max(0, Math.min(this.slides.length - 1, Math.round(Math.abs(this.track.scrollLeft) / (this.track.clientWidth || 1))));
      }
      update(index) {
        const changed = this.index !== index;
        this.index = index;
        this.slides.forEach((slide, position) => {
          if (position !== index && slide.contains(document.activeElement)) this.track.focus({ preventScroll: true });
          slide.inert = position !== index;
          slide.setAttribute('aria-hidden', String(position !== index));
        });
        this.dots.forEach((dot, position) => dot.setAttribute('aria-current', String(position === index)));
        if (changed && this.status && !this.automaticChange) this.status.textContent = this.slides[index].getAttribute('aria-label');
      }
      step(direction, automatic = false) {
        const index = (this.index + direction + this.slides.length) % this.slides.length;
        this.select(index, true, { automatic });
      }
      select(index, animate = true, { automatic = false, swipe = false } = {}) {
        index = Math.max(0, Math.min(this.slides.length - 1, index));
        clearTimeout(this.settleTimer);
        this.stopPlayback();
        this.cancelTransition();
        this.automaticChange = automatic;
        const smooth = animate && !this.motion.matches;
        const fade = smooth && !swipe && index !== this.index && this.dataset.transition !== 'slide';
        const left = index * this.track.clientWidth * this.direction;
        if (fade) {
          this.snapshot = this.slides[this.index].firstElementChild.cloneNode(true);
          this.snapshot.classList.add('nn-swipe-grid__snapshot');
          this.snapshot.inert = true;
          this.snapshot.setAttribute('aria-hidden', 'true');
          this.append(this.snapshot);
          this.track.scrollTo({ left, behavior: 'instant' });
          this.update(index);
          this.transitionAnimation = this.snapshot.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 400, easing: 'ease-in-out' });
          if (this.dataset.transition === 'fade_with_text') {
            this.contentAnimation = this.slides[index].querySelector('.nn-swipe-grid__content')?.animate([{ opacity: 0, transform: 'translateY(14px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 500, easing: 'ease-out' });
          }
          this.transitionAnimation.finished.then(() => {
            this.cancelTransition();
            this.settle();
          }).catch(() => {});
        } else {
          this.track.scrollTo({ left, behavior: smooth ? 'smooth' : 'instant' });
          if (!smooth || Math.abs(this.track.scrollLeft - left) < 1) {
            this.update(index);
            this.settle();
          }
        }
      }
      cancelTransition() {
        this.transitionAnimation?.cancel();
        this.contentAnimation?.cancel();
        this.transitionAnimation = null;
        this.contentAnimation = null;
        this.snapshot?.remove();
        this.snapshot = null;
      }
      settle() {
        if (this.transitionAnimation || this.interacting) return;
        clearTimeout(this.settleTimer);
        this.update(this.nearestIndex());
        this.track.classList.remove('is-settling');
        this.automaticChange = false;
        this.schedule();
      }
      stopPlayback() {
        clearTimeout(this.autoplayTimer);
        this.progressAnimation?.cancel();
        this.progressAnimation = null;
      }
      schedule() {
        this.stopPlayback();
        const paused = this.userPaused || this.focusPaused;
        if (this.playback) {
          this.playback.hidden = this.motion.matches;
          this.playback.toggleAttribute('data-paused', paused);
          this.playback.setAttribute('aria-label', paused ? this.playback.dataset.playLabel : this.playback.dataset.pauseLabel);
        }
        if (!this.isConnected || !this.autoplay || paused || this.motion.matches || this.hovering || this.interacting || this.editorSelected || !this.visible || document.hidden || this.transitionAnimation) return;
        const progress = this.dots[this.index]?.querySelector('.nn-swipe-grid__progress');
        this.progressAnimation = progress?.animate([{ strokeDashoffset: 107 }, { strokeDashoffset: 0 }], { duration: this.duration, easing: 'linear', fill: 'forwards' });
        this.autoplayTimer = setTimeout(() => this.step(1, true), this.duration);
      }
      endDrag(event, cancelled = false) {
        this.interacting = false;
        const pointer = this.pointer;
        if (!pointer || pointer.id !== event.pointerId) {
          this.schedule();
          return;
        }
        this.pointer = null;
        // Keep native snapping disabled until the release animation has finished.
        if (pointer.dragging) this.track.classList.add('is-settling');
        if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
        this.track.classList.remove('is-dragging');
        if (!pointer.dragging) {
          this.schedule();
          return;
        }
        this.suppressClick = true;
        const delta = (pointer.x - event.clientX) * this.direction;
        const advance = !cancelled && Math.abs(delta) >= Math.min(72, this.track.clientWidth * .15);
        this.select(advance ? pointer.index + Math.sign(delta) : pointer.index, true, { swipe: true });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
